import React from 'react';
import cx from 'classnames';
import styles from './ActionImage.module.scss';
import type { ActionImageProps } from './ActionImage.types';
import Image from '../Image';

/**
 * ActionImage component definition.
 */
const ActionImage = (props: ActionImageProps) => {
  const {
    disabled,
    className,
    onClick,
    ...restProps
  } = props;

  const handleClick = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
    if (onClick && !disabled) {
      onClick(e);
    }
  };

  return (
    <div
      role='button'
      aria-label='Action Image'
      aria-disabled={disabled}
      tabIndex={0}
      className={cx(
        styles.actionImage,
        {
          [styles.disabled]: disabled,
        },
        className,
      )}
      onClick={handleClick}
    >
      <Image {...restProps} />
    </div>
  );
};

export default ActionImage;
